import './UnitsAndZoomControl.style.css';

export class UnitsAndZoomControl {
    constructor() {
        this._container = document.createElement('div');
        this._container.classList.add('units-and-zoom-ctrl');
        this._sidebarId = 'unitsAndZoomSidebar';
        this._contentId = 'unitsAndZoomSidebarContent';
        this._zoomButtons = [];
    }

    addZoomButton(title, extent) {
        this._zoomButtons.push({ title: title, extent: extent });
    }

    toggleSidebar(id) {
        const sidebar = document.getElementById(id);

        if (sidebar) {
            sidebar.classList.toggle('sidebar-collapsed');
        }
    }

    onAdd(map) {
        this._map = map;

        const leftSidebar = document.createElement('div');
        leftSidebar.id = this._sidebarId;
        leftSidebar.classList.add('sidebar-parent', 'sidebar-collapsed');

        const sidebarContent = document.createElement('div');
        sidebarContent.id = this._contentId;
        sidebarContent.classList.add('sidebar-content', 'rounded-rect');

        const loading = document.createElement('p');
        loading.textContent = 'Keine Daten';
        sidebarContent.appendChild(loading);

        const sidebarToggle = document.createElement('div');
        sidebarToggle.classList.add('sidebar-toggle', 'rounded-rect');
        sidebarToggle.addEventListener('click', () =>
            this.toggleSidebar(this._sidebarId)
        );
        sidebarToggle.innerHTML = '&ofcir;';

        leftSidebar.appendChild(sidebarContent);
        leftSidebar.appendChild(sidebarToggle);
        this._container.appendChild(leftSidebar);

        return this._container;
    }

    onRemove() {
        this._container.parentNode?.removeChild(this._container);
        delete this._map;
    }

    updateDynamicData(data) {
        const traccarList = [];
        const fzmList = [];

        if ('traccar-positions' in data && data['traccar-positions']) {
            const featureList = data['traccar-positions']['features'];
            featureList.forEach((feature) => {
                traccarList.push({
                    label: feature['properties']['label'],
                    status: parseInt(feature['properties']['teamStatus']),
                    coordinates: feature['geometry']['coordinates'],
                });
            });
        }

        if ('fzm-positions' in data && data['fzm-positions']) {
            const featureList = data['fzm-positions']['features'];
            featureList.forEach((feature) => {
                fzmList.push({
                    label: feature['properties']['label'],
                    status: parseInt(feature['properties']['teamStatus']),
                    coordinates: feature['geometry']['coordinates'],
                });
            });
        }

        this._updateContent(traccarList, fzmList);
    }

    _updateContent(traccarList, fzmList) {
        const content = document.getElementById(this._contentId);
        content.innerHTML = '';

        content.appendChild(this._getZoomButtonContent());

        const unitsCombined = [...traccarList, ...fzmList];
        unitsCombined.sort((a, b) => {
            if (a['label'] < b['label']) return -1;
            if (a['label'] > b['label']) return 1;
            return 0;
        });
        content.appendChild(this._getUnitsContent(undefined, unitsCombined));
    }

    _getZoomButtonContent() {
        const content = document.createElement('div');
        content.classList.add('sidebar-zoom-button-container');

        this._zoomButtons.forEach((zoomButtonInfo) => {
            const button = document.createElement('div');
            button.classList.add('sidebar-zoom-button');
            button.innerText = zoomButtonInfo.title;
            button.addEventListener('click', () => {
                this._map.fitBounds(zoomButtonInfo.extent, {
                    padding: 60,
                });
            });
            content.appendChild(button);
        });

        return content;
    }

    _getUnitsContent(title, units) {
        const content = document.createElement('div');

        if (!units || units.count === 0) {
            return content;
        }

        if (title) {
            const header = document.createElement('h1');
            header.textContent = title;
            content.appendChild(header);
        }

        units.forEach((unit) => {
            const unitContent = document.createElement('div');
            unitContent.classList.add('sidebar-unit-button');

            const unitStatus = document.createElement('div');
            unitStatus.classList.add('sidebar-unit-status');
            if (unit['status'] === 1) {
                unitStatus.classList.add('status1');
            } else if (unit['status'] === 2) {
                unitStatus.classList.add('status2');
            } else if (unit['status'] === 3) {
                unitStatus.classList.add('status3');
            } else if (unit['status'] === 4) {
                unitStatus.classList.add('status4');
            } else if (unit['status'] === 5) {
                unitStatus.classList.add('status5');
            } else if (unit['status'] === 6) {
                unitStatus.classList.add('status6');
            } else {
                unitStatus.classList.add('status0');
            }

            const unitLabel = document.createElement('span');
            unitLabel.textContent = unit['label'];

            unitContent.appendChild(unitStatus);
            unitContent.appendChild(unitLabel);
            unitContent.addEventListener('click', () => {
                this._map.flyTo({
                    center: unit['coordinates'],
                    zoom: 16,
                    speed: 2,
                });
            });
            content.appendChild(unitContent);
        });

        return content;
    }
}
